<template>
    <div class="mvt-rangeslider">
        <div class="mvt-rangeslider-input">
            <input class="from" ref="min" type="range" :value="_valueMinIndex" @input="onChangeMinIndex" :min="minIndex" :max="maxIndex"/>
            <input class="to" ref="max" type="range" :value="_valueMaxIndex" @input="onChangeMaxIndex" :min="minIndex" :max="maxIndex"/>
        </div>
    </div>
</template>
<script src="./mvt-rangeslider.js"></script>
<style lang="scss">
    @use "./mvt-rangeslider.scss" as *;
</style>